<template>
  <div>
    <!-- CONFERENCE SUMMARY MODAL -->
    <div class="text-center">
      <v-dialog 
        v-model="conference_ai_summary"
        max-width="950px"
        style='z-index: 2;'
      >
        <v-row justify="center">
          <v-card :style="'border-top: 5px solid ' + modalColor" min-width="500px">
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-table
                fixed-header
                fixed-footer
                height="80vh"
              >
                <thead>
                  <tr>
                    <th>
                      <v-card-title style="width: 100%;">
                        <v-toolbar class="bg-white">
                          <v-icon
                            :style="'float: left; color: #fff; background-color: ' + modalColor"
                            class="float-left mr-2"
                            @click="store.setConferenceAISummary(false)"
                            >mdi-chevron-left</v-icon
                          >
                          <v-toolbar-title 
                            class="ml-n1"
                            :color="modalColor"
                          >
                            Conference Summary
                          </v-toolbar-title>
                          <v-icon
                            :color="modalColor"
                            class="float-right"
                            @click="$emit('add_note', item)"
                            >mdi-cached</v-icon
                          >
                        </v-toolbar>
                      </v-card-title>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <v-card-text style="width: 100%;">
                        <v-row>
                          <v-col cols="12" md="12" sm="12">
                            <v-toolbar color="rgb(255, 255, 255)">
                              <span class="text-ellipsis font-weight-bolder" :style="'color: ' + modalColor">
                                {{ item.itemName }}
                              </span>
                            </v-toolbar>
                            
                            <v-card
                              class="mx-auto elevation-0"
                              v-if="Object.keys(summary).length > 0 && (summary.summary_content || summary.summary_overview)"
                            >
                              <v-table height="100vh">
                                <tbody>
                                  <tr>
                                    <td>
                                      <div v-html="summary.summary_content"></div>
                                    </td>
                                  </tr>
                                </tbody>
                              </v-table>
                            </v-card>

                            <v-card
                              class="mx-auto elevation-0"
                              v-else
                            >
                              <v-table class="bg-grey-lighten-5" height="100vh">
                                <tbody>
                                  <tr>
                                    <td class="text-center">
                                      <span>
                                        No AI Summary found for this conference
                                      </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </v-table>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </v-form>
          </v-card>
        </v-row>
      </v-dialog>
    </div>
  </div>
</template>

<script>
var moment = require("moment");
import { useAuthStore } from "../../stores/auth";
import { useIndexStore } from "../../stores/index";
import { useAlertStore } from "../../stores/alert";

export default {
  name: "ConferenceAISummary",
  props: {
    summary: {
      type: Array,
      default: () => [],
    },

    modalColor: {
      type: String,
      default: "rgb(86, 182, 229)",
    },

    item: {
      type: Object,
      default: () => ({}),
    },

    moduleCode: {
      type: String,
      default: "RSC",
    },
  },

  data: () => ({
    valid: false,
    comment: "",
    reply: "",
    show: false,
    current_comment: "",
    reply_comment: {},
    opened: [],
    rules: {
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => (v && v.length >= 3) || "Min 3 characters",
      ],
      selectRules: [(v) => !!v || "Select is required"],
      textRules: [
        v => !!v || 'Field is required',
        v => (v && v.length >= 3) || 'Min 3 characters',
      ],
      characterRules: [
        v => (v && v.length >= 3) || 'Min 3 characters',
      ],
    },
    token: localStorage.getItem("token") ? JSON.stringify(localStorage.getItem("token")).slice(1, -1) : "",
    auth: useAuthStore(),
    store: useIndexStore(),
    alert: useAlertStore(),
  }),

  computed: {
    user() {
      return this.auth.getLoggedInUser;
    },

    conference_ai_summary() {
      return this.store.getConferenceAISummary;
    },

    current_pdf() {
      return this.store.getCurrentPdf;
    },
  },
  
  methods: {
    formatDateAndTime(date) {
      return moment.unix(date).utcOffset(180).format("DD MMM YYYY, hh:mm A");
    },

    validate() {
      return this.$refs.form.validate();
    },

    resetForm() {
      return this.$refs.form.reset();
    },

    resetValidation() {
      return this.$refs.form.resetValidation();
    },

    reset() {
      this.reply = "";
      this.comment = "";
      this.resetValidation();
      document.querySelector('html').classList.remove('v-overlay-scroll-blocked');
    },

    noRepliesFound() {
      this.alert.showInfo('No replies found');
    },
  },
};
</script>

<style scoped>
.bubble {
  border-radius: 12px;
  padding: 12px 16px;
  max-width: 90%;
  word-break: break-word;
  display: inline-block;
}
.user-bubble {
  background: #e3f2fd;
  color: #1565c0;
  margin-bottom: 4px;
  margin-left: auto;
  text-align: right;
}
.ai-bubble {
  background: #ede7f6;
  color: #4527a0;
  margin-right: auto;
  text-align: left;
}
.meta {
  font-size: 0.85em;
  color: #888;
  margin-top: 4px;
}
</style>